export interface TeacherMember {
  id: string;
  name: string;
  role: string;
  bio: string;
  image: string;
  location?: string;
  expertise?: string[];
  links?: { label: string; url: string }[];
}

export const teachers: TeacherMember[] = [
  {
    id: 'founder-1',
    name: 'Ahmad Al-Sayed',
    role: 'Founder & Director',
    bio: 'Guiding the academic vision and quality of all Quran and Arabic programs with 12+ years of teaching and curriculum design.',
    image: 'https://img.freepik.com/free-photo/smiling-muslim-man-applauding_482257-103227.jpg?semt=ais_incoming&w=740&q=80',
    location: 'Cairo, Egypt',
    expertise: ['Curriculum', 'Qira’at', 'Leadership'],
    links: [{ label: 'LinkedIn', url: '#' }]
  },
  {
    id: 'cofounder-ops',
    name: 'Maryam Hassan',
    role: 'Operations Lead',
    bio: 'Oversees student onboarding, scheduling logistics, and parent communication ensuring smooth academic flow.',
    image: 'https://img.freepik.com/free-photo/smiling-muslim-man-applauding_482257-103227.jpg?semt=ais_incoming&w=740&q=80',
    location: 'Dubai, UAE',
    expertise: ['Operations', 'Parent Success'],
  },
  {
    id: 'lead-quran',
    name: 'Sheikh Yusuf Karim',
    role: 'Lead Quran Instructor',
    bio: 'Specialist in tajweed delivery and structured memorization pathways with a focus on consistent retention.',
    image: 'https://img.freepik.com/free-photo/smiling-muslim-man-applauding_482257-103227.jpg?semt=ais_incoming&w=740&q=80',
    location: 'Alexandria, Egypt',
    expertise: ['Tajweed', 'Hifdh Coaching'],
  },
  {
    id: 'arabic-head',
    name: 'Fatimah Al-Najjar',
    role: 'Head of Arabic Department',
    bio: 'Designs immersive Arabic learning sequences integrating modern pedagogy and classical linguistic depth.',
    image: 'https://img.freepik.com/free-photo/smiling-muslim-man-applauding_482257-103227.jpg?semt=ais_incoming&w=740&q=80',
    location: 'Doha, Qatar',
    expertise: ['Arabic', 'Pedagogy'],
  },
  {
    id: 'islamic-studies',
    name: 'Dr. Bilal Rahman',
    role: 'Islamic Studies Lecturer',
    bio: 'Bringing classical scholarship into accessible structured sessions covering creed, fiqh basics, and prophetic biography.',
    image: 'https://img.freepik.com/free-photo/smiling-muslim-man-applauding_482257-103227.jpg?semt=ais_incoming&w=740&q=80',
    location: 'Istanbul, Türkiye',
    expertise: ['Aqeedah', 'Seerah', 'Fiqh'],
  },
  {
    id: 'student-success',
    name: 'Layla Mahmoud',
    role: 'Student Success Coordinator',
    bio: 'Ensures learners maintain momentum via tracking, reminders, and individualized study adjustments.',
    image: 'https://img.freepik.com/free-photo/smiling-muslim-man-applauding_482257-103227.jpg?semt=ais_incoming&w=740&q=80',
    location: 'Remote',
    expertise: ['Engagement', 'Learning Pathways'],
  },
  {
    id: 'qasidah',
    name: 'Omar Idris',
    role: 'Recitation Quality Mentor',
    bio: 'Focuses on articulation refinement and applying tajweed consistently in live correction sessions.',
    image: 'https://img.freepik.com/free-photo/smiling-muslim-man-applauding_482257-103227.jpg?semt=ais_incoming&w=740&q=80',
    location: 'Casablanca, Morocco',
    expertise: ['Makharij', 'Tajweed'],
  },
  {
    id: 'tech-lead',
    name: 'Sara Ali',
    role: 'Learning Platform Engineer',
    bio: 'Builds internal tools enhancing tracking visibility, scheduling automation, and progress analytics.',
    image: 'https://img.freepik.com/free-photo/smiling-muslim-man-applauding_482257-103227.jpg?semt=ais_incoming&w=740&q=80',
    location: 'Remote',
    expertise: ['Product', 'Automation'],
  },
];
